const validateAnswer = function (errors, vm, showTip, valIndex) {
  const { answerConfig: { requireInd }, optionList } = this
  let hasUnknown = false
  let optionListFilter = optionList.filter(item => item.visibility)
  if (optionListFilter) {
    hasUnknown = optionListFilter.some(item => item.optionList && item.optionList.length)
  }

  if (requireInd === '1') {
    // 空值校验，排除不清楚/不知道
    if (
      (valIndex !== undefined && !optionListFilter[valIndex].value.trim() && !hasUnknown) ||
      (valIndex !== undefined && !optionListFilter[valIndex].value.trim() && (hasUnknown && !optionListFilter[valIndex].optionList[0].value))
    ) {
      errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
      return !errors.length
    }

    if (valIndex === undefined && optionListFilter.some((item, index) => {
      return !item.value.trim() && (item.optionList && item.optionList.length ? !item.optionList[0].value : true)
    })) {
      errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
      return !errors.length
    }

    // valIndex为undefined时，格式校验
    if (vm.$util.isNull(optionListFilter[valIndex])) {
      // 数字格式校验
      if (optionListFilter.some((item, index) => {
        return isNaN(item.value * 1)
      })) {
        errors.push(vm.cvtLang('tipsNumberLimit', vm.surveyInfoLang.tipsNumberLimit))
        return !errors.length
      }
      // 整数校验
      if (optionListFilter.some((item, index) => {
        return item.answerConfig.precision === 0 && !/^-?\d+$/.test(item.value * 1)
      })) {
        errors.push(vm.cvtLang('tipsIntLimit', vm.surveyInfoLang.tipsIntLimit))
        return !errors.length
      }
      // 1位小数
      if (optionListFilter.some((item, index) => {
        return item.answerConfig.precision === 1 && !/^-?(\d+|\d+\.\d{1,1})$/.test(item.value * 1)
      })) {
        errors.push(vm.cvtLang('tipsOneDecimalLimit', vm.surveyInfoLang.tipsOneDecimalLimit))
        return !errors.length
      }
      // 2位小数
      if (optionListFilter.some((item, index) => {
        return item.answerConfig.precision === 2 && !/^-?(\d+|\d+\.\d{1,2})$/.test(item.value * 1)
      })) {
        errors.push(vm.cvtLang('tipsDecimalLimit', vm.surveyInfoLang.tipsDecimalLimit))
        return !errors.length
      }

      let errorMin = 0
      let errorMax = 0
      let val = 0
      // 范围校验
      if (optionListFilter.some((item, index) => {
        errorMin = item.answerConfig.min
        errorMax = item.answerConfig.max
        val = item.value * 1
        return (
          ((item.answerConfig.min || item.answerConfig.max) && !hasUnknown) ||
          ((item.answerConfig.min || item.answerConfig.max) && (hasUnknown && !item.optionList[0].value))
        ) && (val < errorMin || val > errorMax)
      })) {
        errors.push(
          `${vm.$t('tipRangeNull')}[${errorMin || '-∞'},${errorMax || '+∞'}]`
        )
        return !errors.length
      }
      return !errors.length
    }

    let compareValue = optionListFilter[valIndex].value
    compareValue = compareValue * 1
    const config = optionListFilter[valIndex].answerConfig
    if (isNaN(compareValue)) {
      errors.push(vm.cvtLang('tipsNumberLimit', vm.surveyInfoLang.tipsNumberLimit))
      return !errors.length
    }
    if (config.precision === 0 && !/^-?\d+$/.test(compareValue)) {
      // 整数
      errors.push(vm.cvtLang('tipsIntLimit', vm.surveyInfoLang.tipsIntLimit))
      return !errors.length
    } else if (config.precision === 1 && !/^-?(\d+|\d+\.\d{1,1})$/.test(compareValue)) {
      // 1位小数
      errors.push(vm.cvtLang('tipsOneDecimalLimit', vm.surveyInfoLang.tipsOneDecimalLimit))
      return !errors.length
    } else if (config.precision === 2 && !/^-?(\d+|\d+\.\d{1,2})$/.test(compareValue)) {
      // 2位小数
      errors.push(vm.cvtLang('tipsDecimalLimit', vm.surveyInfoLang.tipsDecimalLimit))
      return !errors.length
    }
    
    // 范围校验，排除不清楚/不知道
    if (
      ((config.min || config.max) && !hasUnknown) ||
      ((config.min || config.max) && (hasUnknown && !optionListFilter[valIndex].optionList[0].value))
    ) {
      if (compareValue < config.min || compareValue > config.max) {
        let errorMin = config.min
        let errorMax = config.max
        errors.push(
          `${vm.$t('tipRangeNull')}[${errorMin || '-∞'},${errorMax || '+∞'}]`
        )
        return !errors.length
      }
    }
  } else {
    // 非空值校验，排除不清楚/不知道

    // valIndex为undefined时，格式校验
    if (vm.$util.isNull(optionListFilter[valIndex])) {
      // 数字格式校验
      if (optionListFilter.some((item, index) => {
        return isNaN(item.value * 1)
      })) {
        errors.push(vm.cvtLang('tipsNumberLimit', vm.surveyInfoLang.tipsNumberLimit))
        return !errors.length
      }
      // 整数校验
      if (optionListFilter.some((item, index) => {
        return item.answerConfig.precision === 0 && !/^-?\d+$/.test(item.value * 1)
      })) {
        errors.push(vm.cvtLang('tipsIntLimit', vm.surveyInfoLang.tipsIntLimit))
        return !errors.length
      }
      // 1位小数
      if (optionListFilter.some((item, index) => {
        return item.answerConfig.precision === 1 && !/^-?(\d+|\d+\.\d{1,1})$/.test(item.value * 1)
      })) {
        errors.push(vm.cvtLang('tipsOneDecimalLimit', vm.surveyInfoLang.tipsOneDecimalLimit))
        return !errors.length
      }
      // 2位小数
      if (optionListFilter.some((item, index) => {
        return item.answerConfig.precision === 2 && !/^-?(\d+|\d+\.\d{1,2})$/.test(item.value * 1)
      })) {
        errors.push(vm.cvtLang('tipsDecimalLimit', vm.surveyInfoLang.tipsDecimalLimit))
        return !errors.length
      }

      let errorMin = 0
      let errorMax = 0
      let val = 0
      // 范围校验
      if (optionListFilter.some((item, index) => {
        errorMin = item.answerConfig.min
        errorMax = item.answerConfig.max
        val = item.value * 1
        return item.value && (
          ((item.answerConfig.min || item.answerConfig.max) && !hasUnknown) ||
          ((item.answerConfig.min || item.answerConfig.max) && (hasUnknown && !item.optionList[0].value))
        ) && (val < errorMin || val > errorMax)
      })) {
        errors.push(
          `${vm.$t('tipRangeNull')}[${errorMin || '-∞'},${errorMax || '+∞'}]`
        )
        return !errors.length
      }
      return !errors.length
    }

    let compareValue = optionListFilter[valIndex].value
    compareValue = compareValue * 1
    const config = optionListFilter[valIndex].answerConfig
    if (isNaN(compareValue)) {
      errors.push(vm.cvtLang('tipsNumberLimit', vm.surveyInfoLang.tipsNumberLimit))
      return !errors.length
    }
    if (config.precision === 0 && !/^-?\d+$/.test(compareValue)) {
      // 整数
      errors.push(vm.cvtLang('tipsIntLimit', vm.surveyInfoLang.tipsIntLimit))
      return !errors.length
    } else if (config.precision === 1 && !/^-?(\d+|\d+\.\d{1,1})$/.test(compareValue)) {
      // 1位小数
      errors.push(vm.cvtLang('tipsOneDecimalLimit', vm.surveyInfoLang.tipsOneDecimalLimit))
      return !errors.length
    } else if (config.precision === 2 && !/^-?(\d+|\d+\.\d{1,2})$/.test(compareValue)) {
      // 2位小数
      errors.push(vm.cvtLang('tipsDecimalLimit', vm.surveyInfoLang.tipsDecimalLimit))
      return !errors.length
    }
    
    // 范围校验，排除不清楚/不知道
    if (
      optionListFilter[valIndex].value &&
      (
        ((config.min || config.max) && !hasUnknown) ||
        ((config.min || config.max) && (hasUnknown && !optionListFilter[valIndex].optionList[0].value))
      )
    ) {
      if (compareValue < config.min || compareValue > config.max) {
        let errorMin = config.min
        let errorMax = config.max
        errors.push(
          `${vm.$t('tipRangeNull')}[${errorMin || '-∞'},${errorMax || '+∞'}]`
        )
        return !errors.length
      }
    }

  }

  return !errors.length
}

const validate = function (vm, showTip, valIndex) {
  const errors = []
  return {
    result: validateAnswer.call(this, errors, vm, showTip, valIndex),
    errors
  }
}

const answerValidate = {
  validateAnswer,
  validate
}

export default answerValidate



// WEBPACK FOOTER //
// ./src/components/editor/MultiNumberBox/answerValidate.js